import { Button, colors, Grid, TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import React, { useRef, useState } from 'react';
import SearchBar from 'src/components/SearchBar';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  button: {
    marginRight: theme.spacing(1),
    height: '52px',
  },
  divider: {
    backgroundColor: colors.grey[300],
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  marginRight: {
    paddingRight: '0 !important',
  },
  btnDiv: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

function SubHeadButtons({
  selectOptions = [],
  subHeadConfig,
  onDropdownChange,
  onSearchClick,
  onSearchChange,
  onButtonClick,
  onInputChange,
  resetInput,
}) {
  const classes = useStyles();
  const saving = false;
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const inputRef = useRef('');
  const dropDownRef = useRef('');

  const [selectedOptions, setSelectedOptions] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [buttonDisableState, setButtonDisableState] = useState([true]);
  const [inputBoxState, setInputBoxState] = useState('');
  const [resetAutocomplete, setResetAutoComplete] = useState(0);

  const handleDropDownChange = selectedOptions => {
    setSelectedOptions(selectedOptions);
    onDropdownChange(selectedOptions);
  };

  const handleInputChange = event => {
    if (subHeadConfig.validate) {
      if (inputRef.current.value && inputRef.current.value.trim()) {
        setButtonDisableState(true);
      } else {
        setButtonDisableState(false);
      }
    }

    if (typeof onInputChange === 'function') {
      onInputChange(event, inputRef);
    }
  };

  const getSearchBar = (elementConfig, index) => {
    const { placeholder, buttontext, hidebutton, disable } = elementConfig;

    return (
      <Grid item sm={4} lg={4} xs={12} key={index}>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <SearchBar
              onSearch={onSearchClick}
              onChange={onSearchChange}
              placeholder={placeholder}
              buttontext={buttontext}
              hidebutton={hidebutton.toString()}
              resetInput={resetInput}
              disabled={disable}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const getDropdownInput = (elementConfig, index) => {
    const { mapDataKey, label, Id, disabled } = elementConfig;
    return (
      <Grid item sm={2} lg={2} className={classes.marginRight} key={index}>
        <Autocomplete
          key={resetAutocomplete}
          multiple
          id={Id}
          options={selectOptions}
          disableCloseOnSelect
          disabled={disabled}
          getOptionLabel={option => option[mapDataKey]}
          onChange={(_, selectedOptions) => handleDropDownChange(selectedOptions)}
          renderOption={(option, { selected }) => (
            <>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option[mapDataKey]}
            </>
          )}
          renderInput={params => <TextField {...params} variant="outlined" label={label} />}
          ref={dropDownRef}
        />
      </Grid>
    );
  };

  const getInputBox = (elementConfig, index) => {
    const { inputId, inputName, inputLabel, disabled } = elementConfig;
    return (
      <Grid item sm={2} lg={2} key={index}>
        <TextField
          fullWidth
          id={inputId}
          name={inputName}
          label={inputLabel}
          onChange={event => {
            setInputBoxState(event.target.value);
            return handleInputChange(event);
          }}
          variant="outlined"
          className="classes.input"
          value={inputBoxState}
          disabled={disabled}
        />
      </Grid>
    );
  };

  const getButton = (elementConfig, index) => {
    const { buttonText, savingText, disabled, variant, lg, sm, startIcon } = elementConfig;

    return (
      <Grid item sm={sm || 2} lg={lg || 2} key={index}>
        <Button
          fullWidth
          variant={variant}
          color="primary"
          className={classes.button}
          disabled={disabled}
          startIcon={startIcon}
          onClick={() => {
            setInputBoxState('');
            setResetAutoComplete(resetAutocomplete + 1);
            return onButtonClick
              ? onButtonClick(buttonText, inputBoxState, selectedOptions)
              : onButtonClick;
          }}
        >
          {saving ? savingText : buttonText}
        </Button>
      </Grid>
    );
  };

  const getHidden = (elementConfig, index) => <Grid item sm={1} lg={1} key={index} />;

  const buildSubHead = block => {
    const { elementsList } = block;
    const subHead = elementsList.map((element, index) => {
      const { elementType, elementConfig } = element;
      switch (elementType) {
        case 'searchBar':
          return getSearchBar(elementConfig, index);
        case 'inputBox':
          return getInputBox(elementConfig, index);
        case 'dropDownInput':
          return getDropdownInput(elementConfig, index);
        case 'button':
          return getButton(elementConfig, index);
        case 'hidden':
          return getHidden(elementConfig, index);
        default:
          return null;
      }
    });

    return subHead;
  };

  return (
    <Grid container spacing={3} className={classes.btnDiv} alignItems="stretch">
      {subHeadConfig &&
        subHeadConfig.blocks &&
        subHeadConfig.blocks.map((element, index) => buildSubHead(element, index))}
    </Grid>
  );
}

export { SubHeadButtons };
